@let p = post();
<article
  class="blog-card"
  grooveSurface
  variant="bordered"
  [interactive]="true"
>
  @if (thumbnailUrl(); as src) {
    <!-- groove-img-duotone(--warm): blog thumbnails are a MIX of full-range
         photos and flat light line-art (notation graphics). The default cobalt
         duotone reads fine on photos but collapses the graphics into a uniform
         pale-blue wall. Since the card cannot detect a thumb's content, ALL
         thumbs take the warm (sepia) treatment — it de-uniforms the graphics
         while keeping photos cohesive, and reads as intentional editorial. -->
    <a
      class="blog-card-thumbnail groove-img-duotone groove-img-duotone--warm"
      [routerLink]="['/blog', p.slug]"
      tabindex="-1"
      aria-hidden="true"
    >
      <img [src]="src" alt="" width="480" height="360" loading="lazy" />
    </a>
  } @else {
    <a
      class="blog-card-placeholder"
      [routerLink]="['/blog', p.slug]"
      tabindex="-1"
      aria-hidden="true"
    >
      <img
        src="/images/russlogo-200x200-black-bg.webp"
        alt=""
        width="120"
        height="120"
        loading="lazy"
      />
    </a>
  }

  <div class="blog-card-body">
    <h2 class="blog-card-title">
      <a [routerLink]="['/blog', p.slug]">{{ p.title }}</a>
    </h2>

    <p class="blog-card-meta">
      <time [attr.datetime]="p.datePublished">
        {{ p.datePublished | date: "mediumDate" }}
      </time>
      <span aria-hidden="true">·</span>
      <a [routerLink]="['/blog/topic', p.category]">{{ categoryLabel() }}</a>
      <span aria-hidden="true">·</span>
      <a class="blog-card-level" [routerLink]="['/blog/difficulty', p.level]">
        {{ levelLabel() }}
      </a>
      <span aria-hidden="true">·</span>
      <span>{{ p.readingTimeMinutes }} min read</span>
    </p>

    <p class="blog-card-excerpt">{{ p.excerpt }}</p>

    @if (visibleTags().length > 0) {
      <ul class="blog-card-tags" aria-label="Tags">
        @for (tag of visibleTags(); track tag) {
          <li>
            <a grooveBadge tone="muted" [routerLink]="['/blog/tag', tag]"
              >#{{ tag }}</a
            >
          </li>
        }
      </ul>
    }
  </div>
</article>
